export default ()=>{
    const buyBtns = document.querySelectorAll('.product-actions__add');

    buyBtns.length>0?addToCart():false;
    function addToCart(){
        buyBtns.forEach(button =>{
            button.addEventListener('click', (e)=>{
                e.preventDefault();
                const form = button.closest('form');
                let id = form.elements.id.value;
                let quantity = form.elements.quantity.value;
                ac(id, quantity, e);
            })
        })
    }
}